<template>
    <TransitionRoot as="template" :show="true">
        <Dialog as="div" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-center">
                            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                                <font-awesome-icon :icon="faBullhorn" class="h-6 w-6 text-blue-500" aria-hidden="true" />
                            </div>
                            <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 mt-4">
                                New! Share Your Expertise on RentRisk
                            </DialogTitle>
                            <div class="text-sm space-y-3 text-gray-700 text-left mt-4">
                                <p>You can now publish blog posts to attract leads, build credibility, and educate the community.</p>

                                <p class="font-medium">To get started:</p>
                                <ul class="list-disc list-inside space-y-1">
                                    <li>Click your name in the top right and go to <strong>"My Profile"</strong>.</li>
                                    <li>Add your <strong>profile picture</strong>, <strong>social media links</strong>, and <strong>website</strong>.</li>
                                    <li>Click <strong>"Save"</strong>.</li>
                                    <li>Go to <strong>"Resources"</strong> and click <strong>"Write a Blog"</strong>.</li>
                                    <li>Share your insights and help others while growing your reach!</li>
                                </ul>
                            </div>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
                            <button type="button" class="whiteButton" @click="$emit('closeAlert')">Close</button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script setup>import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBullhorn } from '@fortawesome/pro-light-svg-icons'

import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";

</script>
